import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button, FormGroup, InputGroup, FormControl } from "react-bootstrap";

class SearchField extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value: "",
			defaultValue: undefined,
		};
	}

	componentDidUpdate({ defaultValue: prevDefaultValue }) {
		const { defaultValue } = this.props;
		if (prevDefaultValue !== defaultValue) {
			// The following ESLint disable is a temporary one until this component has been refactored.
			// The default value prop will not be needed after refactoring.
			// eslint-disable-next-line react/no-did-update-set-state
			this.setState({ defaultValue });
		}
	}

	onChange = ({ target: { value } }) => this.setState({ value, defaultValue: undefined });

	onKeyPress = ({ key }) => {
		// Execute search onPress Enter
		if (key === "Enter") {
			this.onSearch();
		}
	};

	onSearch = () => {
		const { onQuickSearch } = this.props;
		const { value } = this.state;

		onQuickSearch(value);
	};

	onClear = () => {
		const { onQuickSearch } = this.props;

		this.setState({ value: "" });

		onQuickSearch("");
	};

	render() {
		const { placeholder, isClearable, onChange, onClear, formGroupClass, iconClass } =
			this.props;
		const { value, defaultValue } = this.state;
		const { lang } = global;

		return (
			<FormGroup className={formGroupClass}>
				<InputGroup>
					<div className="search-field">
						<FormControl
							className="padding-right-30"
							name="search-field"
							value={defaultValue ?? value}
							placeholder={placeholder}
							onChange={onChange instanceof Function ? onChange : this.onChange}
							onKeyPress={this.onKeyPress}
						/>
						<If condition={isClearable && value !== ""}>
							<button
								type="button"
								tabIndex={0}
								aria-label={lang.t("Clear")}
								className="'cursor-pointer clear rkf rkf-cross"
								onClick={onClear instanceof Function ? onClear : this.onClear}
							/>
						</If>
					</div>
					<InputGroup.Button>
						<Button onClick={this.onSearch}>
							<i className={iconClass} />
						</Button>
					</InputGroup.Button>
				</InputGroup>
			</FormGroup>
		);
	}
}

SearchField.propTypes = {
	onQuickSearch: PropTypes.func.isRequired,
	onChange: PropTypes.func,
	onClear: PropTypes.func,
	placeholder: PropTypes.string,
	isClearable: PropTypes.bool,
	defaultValue: PropTypes.string,
	formGroupClass: PropTypes.string,
	iconClass: PropTypes.string,
};

SearchField.defaultProps = {
	placeholder: "",
	isClearable: false,
	onChange: undefined,
	onClear: undefined,
	defaultValue: undefined,
	formGroupClass: "",
	iconClass: "rkf rkf-search",
};

export default SearchField;
